
import { AboutMe } from "../Types/AboutMe";
import { Lang } from "../Types/Lang";

type Props = {
  data: AboutMe;
  lang: Lang;
  title: string;
};

export default function AboutMeComponent({ data, lang, title }: Props) {
  const paragraphs = data.text[lang].split("\n\n");

  return (
    <section className="cv-section">
      <div className="cv-card space-y-5">
        <h2 className="cv-heading">{title}</h2>

        <div className="space-y-4">
          {paragraphs.map((paragraph, index) => (
            <p key={index} className="cv-text">
              {paragraph}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
}
